import { connect } from 'react-redux';
import Layout from '../../../components/navbar/Layout';

export default connect(
    state => ({
    }),
    {},
)(Layout);
